module.exports = __webpack_public_path__ + "static/media/4.aa6bf258.png";